import { css } from "@emotion/react";
import Ginza from "@/module/fonts/ShiseidoGinza.woff";
import GinzaBold from "@/module/fonts/ShiseidoGinza-Bold.woff";

const fontFaces = css(`
  @font-face {
    font-family: "Ginza";
    font-weight: 400;
    src: url(${Ginza}) format("woff");
  }
  @font-face {
    font-family: "Ginza";
    font-weight: 500;
    src: url(${GinzaBold}) format("woff");
  }
`);

export default fontFaces;
